export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-burst-sale-26da20810458aa14947132ee1cf2322d.svg";